// Angular
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AccountService } from '../../../../../mbs/services/account/account.service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { UserService } from '../../../../../mbs/services/user/user.service';

@Component({
    selector: 'kt-users-detail',
    templateUrl: './users-detail.component.html',
    styleUrls: ['users-detail.component.scss'],
})
export class UsersDetailComponent implements OnInit {
    userId: number;
    accountCv: any;
    progressCompletedRatio = 0;
    progressColor = 'danger';
    constructor(private cdr: ChangeDetectorRef, private accountService: AccountService, private activatedRoute: ActivatedRoute, private confirmationService: ConfirmationService, private userService: UserService) {}

    ngOnInit(): void {
        this.userId = this.activatedRoute.snapshot.params['id'];
        this.getCvByUserId();
    }

    getCvByUserId() {
        const inputUserId = { UserId: this.userId };
        this.accountService.getCvByUserId(inputUserId).subscribe((myCv) => {
            this.accountCv = myCv;
            let progressCompletedRatio = 0;
            progressCompletedRatio += myCv.educationInformations.length > 0 ? 20 : 0;
            progressCompletedRatio += myCv.workExperiences.length > 0 ? 20 : 0;
            progressCompletedRatio += myCv.certificateInformations.length > 0 ? 20 : 0;
            progressCompletedRatio += myCv.internshipInformations.length > 0 ? 20 : 0;
            progressCompletedRatio += myCv.foreignLanguageInformations.length > 0 ? 20 : 0;
            this.progressCompletedRatio = progressCompletedRatio;

            this.progressColor = this.calculateProgressColor(this.progressCompletedRatio);
            this.cdr.detectChanges();
        });
    }

    private calculateProgressColor(percent: number) {
        if (percent <= 20) {
            return 'danger';
        } else if (percent <= 40) {
            return 'warning';
        } else if (percent <= 60) {
            return 'primary';
        } else if (percent <= 80) {
            return 'info';
        } else if (percent <= 100) {
            return 'success';
        }
    }

    updateEducationInformationFromYoksis() {
        debugger;
        this.confirmationService.confirm({
            header: 'Onay',
            acceptLabel: 'Evet',
            rejectLabel: 'Hayır',
            message: 'Eğitim bilgileri Yöksis üzerinden güncellenecektir. Devam etmek istiyor musunuz?',
            accept: () => {
                this.userService.updateEducationInformationFromYoksis(this.userId).subscribe((result) => {       
                    this.cdr.detectChanges();
                    if (result.success == true) {
                        this.getCvByUserId();
                    }
                });
            },
        });
    }

    updateIdentificationInformationFromMernis() {
        debugger;
        this.confirmationService.confirm({
            header: 'Onay',
            acceptLabel: 'Evet',
            rejectLabel: 'Hayır',
            message: 'Kimlik bilgileri Mernis üzerinden güncellenecektir. Devam etmek istiyor musunuz?',
            accept: () => {
                this.userService.updateUserDetailFromMernis(this.userId).subscribe((result) => {
                    this.cdr.detectChanges();
                    if (result.success == true) {
                        this.getCvByUserId();
                    }
                });
            },
        });
    }
}
